import { RegisteredRouter, useRouter } from "@tanstack/react-router";
import { useGraphqlMutation } from "shared/hooks/useGraphql";
import { notify } from "shared/utils/notify";
import { graphql } from "src/gql";

export function useIpawsAlertActions() {
    const cancel = useGraphqlMutation(muts.cancel);
    const validate = useGraphqlMutation(muts.validate);

    const router = useRouter() as RegisteredRouter | null;
    const nav = router?.navigate;

    return {
        async openCancelModal(opts: { alertId: string }) {
            const modal = await notify.confirm("Are you sure you want to CANCEL this Alert? This action cannot be undone.", {
                title: "Cancel IPAWS Alert",
                label: "Cancel Alert",
                cancelLabel: "Close",
            });

            const { message } = await cancel.mutateAsync({ alertId: opts.alertId });
            await nav?.({ to: "/ipaws/alerts/$alertId", params: { alertId: message.id } });
            notify.show.success("Sent CANCEL message.");

            modal.close();
        },
        validate,
    };
}

const muts = {
    cancel: graphql(`
        mutation IpawsAlertCancel($alertId: UUID!) {
            message: cancelIpawsAlert(id: $alertId) {
                id
            }
        }
    `),
    validate: graphql(`
        query IpawsAlertFormPolygonValidate($certId: UUID!, $polygons: [GeoPolygon!]!) {
            result: validateIpawsAlertBoundary(params: { certId: $certId, boundary: $polygons }) {
                success
                details {
                    success
                    polygon
                    errorCodes
                }
            }
        }
    `),
};
